import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API } from "./api";

export const useReviewSummary = () => useQuery({ queryKey: ["reviews-summary"], queryFn: () => axios.get(`${API}/reviews/summary`).then((r) => r.data), staleTime: 60000 });
export const useReviews = (handle) => useQuery({ queryKey: ["reviews", handle || "all"], queryFn: () => axios.get(`${API}/reviews`, { params: { handle, limit: handle ? 50 : 10 } }).then((r) => r.data) });
export const submitReview = (body) => axios.post(`${API}/reviews`, body).then((r) => r.data);
export const photoUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;
export const uploadPhoto = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/reviews/photos`, fd).then((r) => r.data);
};

const admin = axios.create({ baseURL: API, withCredentials: true });
export const adminApi = {
  login: (email, password) => admin.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => admin.post("/auth/logout"),
  me: () => admin.get("/auth/me").then((r) => r.data),
  list: (status) => admin.get("/admin/reviews", { params: { status } }).then((r) => r.data),
  setStatus: (id, status) => admin.patch(`/admin/reviews/${id}`, { status }),
  remove: (id) => admin.delete(`/admin/reviews/${id}`),
  changePassword: (current_password, new_password) => admin.post("/auth/change-password", { current_password, new_password }),
  inquiries: () => admin.get("/admin/partner-inquiries").then((r) => r.data),
};

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
};
